"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Localize_1 = require("../../gen-src/Localize");
function createCatalogBreadcrumb(urls, urlSuffix) {
    if (urlSuffix === void 0) { urlSuffix = ''; }
    return {
        id: 'catalog',
        text: Localize_1.Messages.ExternalAssets(),
        href: urls.catalogUrl() + urlSuffix,
        tooltip: Localize_1.Messages.ExternalAssets(),
        testId: 'breadcrumb-catalog',
    };
}
exports.createCatalogBreadcrumb = createCatalogBreadcrumb;
function createCatalogDatabasesBreadcrumb(urls, urlSuffix) {
    if (urlSuffix === void 0) { urlSuffix = ''; }
    // Everything but href intentionally same as root catalog breadcrumb.
    // This matches the behavior of the "Explore" breadcrumb.
    return {
        id: 'catalog',
        text: Localize_1.Messages.ExternalAssets(),
        href: urls.catalogDatabasesUrl() + urlSuffix,
        tooltip: Localize_1.Messages.ExternalAssets(),
        testId: 'breadcrumb-catalog',
    };
}
exports.createCatalogDatabasesBreadcrumb = createCatalogDatabasesBreadcrumb;
function createCatalogTablesBreadcrumb(urls, urlSuffix) {
    if (urlSuffix === void 0) { urlSuffix = ''; }
    // Everything but href intentionally same as root catalog breadcrumb.
    // This matches the behavior of the "Explore" breadcrumb.
    return {
        id: 'catalog',
        text: Localize_1.Messages.ExternalAssets(),
        href: urls.catalogTablesUrl() + urlSuffix,
        tooltip: Localize_1.Messages.ExternalAssets(),
        testId: 'breadcrumb-catalog',
    };
}
exports.createCatalogTablesBreadcrumb = createCatalogTablesBreadcrumb;
function createCatalogTableBreadcrumb(tableId, tableName, urls, urlSuffix) {
    if (urlSuffix === void 0) { urlSuffix = ''; }
    return {
        id: 'catalog-table-' + tableId,
        text: tableName,
        href: urls.catalogTableUrl(tableId) + urlSuffix,
        tooltip: tableName,
        testId: 'breadcrumb-catalog-table-' + tableId,
    };
}
exports.createCatalogTableBreadcrumb = createCatalogTableBreadcrumb;
function createCatalogDatabaseBreadcrumb(databaseId, databaseName, urls, urlSuffix) {
    if (urlSuffix === void 0) { urlSuffix = ''; }
    return {
        id: 'catalog-database-' + databaseId,
        text: databaseName,
        href: urls.catalogDatabaseUrl(databaseId) + urlSuffix,
        tooltip: databaseName,
        testId: 'breadcrumb-catalog-database-' + databaseId
    };
}
exports.createCatalogDatabaseBreadcrumb = createCatalogDatabaseBreadcrumb;
//# sourceMappingURL=BreadcrumbFactories.js.map